import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, OutlinedInput, useTheme } from "@mui/material";
import classNames from "classnames";
import React, { ChangeEvent } from "react";

import { useDebouncedCallback } from "@/shared/hooks";

import { KeywordFilter } from "../filter";

import styles from "./FilterInput.module.css";

interface FilterInputProps {
  onFilterChange: (filter: KeywordFilter) => void;
  className?: classNames.Argument;
  initialValue?: string;
}

export function FilterInput(props: FilterInputProps) {
  const theme = useTheme();
  const { onFilterChange, className, initialValue = "" } = props;

  const handleChange = React.useCallback(
    function handleChange(event: ChangeEvent<HTMLInputElement>) {
      const term = event.target.value;
      onFilterChange({ type: "keyword", term });
    },
    [onFilterChange],
  );

  const handleChangeDebounced = useDebouncedCallback(handleChange, 300);

  return (
    <div className={classNames(className)}>
      <OutlinedInput
        defaultValue={initialValue}
        size="small"
        fullWidth
        placeholder="Filter topics by name"
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon className={styles.icon} />
          </InputAdornment>
        }
        sx={{
          backgroundColor: theme.palette.paper.main,
        }}
        onChange={handleChangeDebounced}
        inputProps={{
          className: styles.inputBaseChild,
        }}
      />
    </div>
  );
}
